import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { Form, Input } from 'semantic-ui-react';
import {
  firstError, firstResponseError, pruneServerErrors, validationClasses,
} from '@/utils/errors';
import fields, { globalFieldLengths } from '@/constants/fields';
import FormValidationError from '@/components/errors/FormValidationError';
import { states } from '@/constants/lifecycle';
import Dialog from '@/components/dialogs/Dialog';
import { hideSaveUserGroupDialog, createUserGroup } from '../actions/usergroups/create';
import { updateActiveUserGroupProperties } from '../actions/usergroups/update';
import { validateUserGroupCode } from '../helper';

const SaveUserGroupDialog = ({
  code,
  hide,
  name,
  postData,
  saveErrors,
  saveStatus,
  theme,
  updateProperties,
}) => {
  const intl = useIntl();
  const codeChange = (e) => {
    updateProperties({ code: e.target.value });
  };

  const handleDismiss = () => {
    updateProperties({ saveErrors: pruneServerErrors(saveErrors) });
  };

  const validateForm = () => [
    validateUserGroupCode({ code }, intl),
  ].filter((truthy) => !!truthy);

  const checkForErrors = () => {
    const validationErrors = validateForm();
    updateProperties({ saveErrors: validationErrors });

    return validationErrors;
  };

  const submitForm = () => {
    const validationErrors = checkForErrors();

    if (validationErrors.length === 0) {
      postData();
    }
  };

  const codeError = saveErrors.find((e) => (e.fields.includes(fields.CODE)));

  return (
    <Dialog
      className="aridhia-save-usergroup-dialog"
      error={firstResponseError(saveErrors)}
      icon="users"
      inProgress={saveStatus === states.PENDING}
      message="usergroup.create.text"
      messageIcon="save"
      minimumDataEntryMet={name}
      onClose={hide}
      onDismiss={handleDismiss}
      onSave={submitForm}
      saveText="save.usergroup.create.button"
      theme={theme}
      title={intl.formatMessage({ id: 'save.usergroup.create.title' })}
      values={{ name }}
    >
      <Form autoComplete="off" onSubmit={submitForm} error={firstError(saveErrors) !== null}>
        <FormValidationError
          error={codeError}
          htmlFor="usergroup_code"
          labelId="save.usergroup.code"
          position="right"
        >
          <Input
            id="usergroup_code"
            size="large"
            disabled={saveStatus === states.PENDING}
            type="custom"
            placeholder={intl.formatMessage({ id: 'save.usergroup.code.placeholder' })}
            value={code || ''}
            maxLength={globalFieldLengths.code}
            onChange={codeChange}
            className={validationClasses(codeError)}
          />
        </FormValidationError>
      </Form>
    </Dialog>
  );
};

const mapStateToProps = ({
  userGroups: {
    activeUserGroup: {
      code,
      description,
      name,
      saveErrors,
      saveStatus,
    },
  },
}) => ({
  code,
  name,
  description,
  saveErrors,
  saveStatus,
});

const mapDispatchToProps = {
  hide: hideSaveUserGroupDialog,
  updateProperties: (properties) => updateActiveUserGroupProperties(properties),
  postData: (token) => createUserGroup(token),
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveUserGroupDialog);
